import { createFileRoute } from "@tanstack/react-router";
import { UpptackView } from "@/lib/features/UpptackView";
export const Route = createFileRoute("/_app/upptack/")({
  component: UpptackView
});